import * as Sentry from "@sentry/react";
import ChunkErrorFallback from "./ChunckErrorFallback";
import { useSelector } from "react-redux";
import { userSelector } from "appredux/selectors";

// eslint-disable-next-line react/prop-types
function SentryErrorBoundary({ children, ...props }) {
  const user = useSelector(userSelector);

  return (
    <Sentry.ErrorBoundary
      fallback={(args) => <ChunkErrorFallback {...args} />}
      dialogOptions={{
        user: {
          name: user?.name,
          email: user?.email,
        },
      }}
      {...props}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}

export default SentryErrorBoundary;
